import React from "react";
import styles from "./BotTableRow.module.css";
import classnames from "classnames";
import {BotInListDTO} from "../../../../../api/generated";
import {Actions} from "../../../../elements/actions/Actions";
import {FormName} from "../../../../elements/formProvider/formSlice";
import {PopupModalName} from "../../../../elements/popupModalProvider/popupModalSlice";
import {Link} from "react-router-dom";

interface BotTableRowProps {
    index: number
    bot: BotInListDTO
    isLastRow: boolean
}


export const BotTableRow: React.FC<BotTableRowProps> = ({index, bot, isLastRow}) => {

    const publicId = bot.publicId

    const hasWarnings = !!bot.hasWarnings

    const getBackgroundColor = () => {
        if (bot.usedConversationPercentage > 80) {
            return "#FFC8CE"
        } else if (bot.usedConversationPercentage < 35) {
            return "#D4F8D3"
        } else {
            return "#FFF0BB"
        }
    }

    return <div
        className={classnames(
            styles.wrapper,
            isLastRow && styles.lastRow,
            bot.hasConfigurationErrors && styles.hasConfigErrors,
            !bot.hasConfigurationErrors && hasWarnings && styles.hasWarning
        )}
    >
        <Link className={styles.rowLink} to={`/assistants/${publicId}`}>
            <span className={styles.dealerCell}>
                {bot.siteName}
                {bot.hasConfigurationErrors && (
                    <img
                        className={styles.alertIcon}
                        src={"/alertIcon.svg"}
                        alt="Needs configuration"
                        title="Assistant requires configuration before it is ready"
                    />
                )}
            </span>
            <span className={styles.websiteCell}>{bot.siteURL}</span>
            <span className={styles.convCountAllCell}>{bot.conversationCountAllTime}</span>
            <span className={styles.convCountMonthlyCell}>{bot.conversationCountLastRenewalDate}</span>
            <span className={styles.usedConvosCell}>
                <span className={styles.usedConvosCellValueWrapper} style={{backgroundColor: getBackgroundColor()}}>
                    {bot.usedConversationPercentage}%
                </span>
            </span>
        </Link>
        <span className={styles.actionsCell} onClick={event => event.stopPropagation()}>
            <Actions
                index={index}
                publicId={bot.publicId}
                editFormName={FormName.UPDATE_BOT}
                deleteModalName={PopupModalName.DELETE_BOT}
                entityName={bot.siteName}
            />
        </span>
    </div>
}
